import { Injectable } from '@angular/core';
import { ActionsService } from './actions.service';

@Injectable({
  providedIn: 'root',
})
export class ImpersonationService {
  private static readonly TOKEN = 'token';
  private static readonly ORIGIN_TOKEN = 'origin-token';
  private static readonly IMPERSONATED = 'imp';

  constructor(private actionsService: ActionsService) {}

  public start(token: string): void {
    const originalToken = localStorage.getItem(ImpersonationService.TOKEN);
    localStorage.removeItem(ImpersonationService.TOKEN);
    if (token) {
      localStorage.setItem(ImpersonationService.TOKEN, token);
    }
    localStorage.setItem(ImpersonationService.IMPERSONATED, JSON.stringify(true));

    // make sure that if preview stopped the original user will be displayed
    if (!localStorage.getItem(ImpersonationService.ORIGIN_TOKEN)) {
      localStorage.setItem(ImpersonationService.ORIGIN_TOKEN, originalToken);
    }

    this.actionsService.reset();
  }

  public stop(): void {
    localStorage.removeItem(ImpersonationService.TOKEN);
    if (localStorage.getItem(ImpersonationService.ORIGIN_TOKEN)) {
      localStorage.setItem(ImpersonationService.TOKEN, localStorage.getItem(ImpersonationService.ORIGIN_TOKEN));
    }
    localStorage.removeItem(ImpersonationService.IMPERSONATED);
    localStorage.removeItem(ImpersonationService.ORIGIN_TOKEN);

    this.actionsService.reset();
  }
}
